import type { ChartGranularity } from '@/types';
import { AUDIENCE_PAGE } from '@/utils/constants';
import { mixpanelTrack } from '@/utils/mixpanelUtils/asyncMixpanel';
import { MIXPANEL_EVENT, RevenueDashboardWidget } from '@/utils/mixpanelUtils/events';

export const trackAudienceAgeModalOpened = () =>
  mixpanelTrack(MIXPANEL_EVENT.audience.ageModal.opened, {
    widget: RevenueDashboardWidget.AgeDemographics,
    page: AUDIENCE_PAGE,
  });

export const trackAudienceAgeModalDownloadClicked = () =>
  mixpanelTrack(MIXPANEL_EVENT.audience.ageModal.downloadClicked, {
    widget: RevenueDashboardWidget.AgeDemographics,
    page: AUDIENCE_PAGE,
  });

export const trackAudienceGenderModalOpened = () =>
  mixpanelTrack(MIXPANEL_EVENT.audience.genderModal.opened, {
    widget: RevenueDashboardWidget.GenderDemographics,
    page: AUDIENCE_PAGE,
  });

export const trackAudienceGenderModalDownloadClicked = () =>
  mixpanelTrack(MIXPANEL_EVENT.audience.genderModal.downloadClicked, {
    widget: RevenueDashboardWidget.GenderDemographics,
    page: AUDIENCE_PAGE,
  });

export const trackAudienceLocationModalOpened = () =>
  mixpanelTrack(MIXPANEL_EVENT.audience.locationModal.opened, {
    widget: RevenueDashboardWidget.LocationDemographics,
    page: AUDIENCE_PAGE,
  });

export const trackAudienceLocationModalDownloadClicked = () =>
  mixpanelTrack(MIXPANEL_EVENT.audience.locationModal.downloadClicked, {
    widget: RevenueDashboardWidget.LocationDemographics,
    page: AUDIENCE_PAGE,
  });

export const trackAudienceLocationModalHideSocialsToggled = (enabled: boolean) =>
  mixpanelTrack(MIXPANEL_EVENT.audience.locationModal.hideSocialsToggled, {
    widget: RevenueDashboardWidget.LocationDemographics,
    page: AUDIENCE_PAGE,
    enabled,
  });

export const trackAudienceTopPlayersModalOpened = () =>
  mixpanelTrack(MIXPANEL_EVENT.audience.topPlayersModal.opened, {
    widget: RevenueDashboardWidget.TopPlayers,
    page: AUDIENCE_PAGE,
  });

export const trackAudienceTopPlayersModalDownloadClicked = () =>
  mixpanelTrack(MIXPANEL_EVENT.audience.topPlayersModal.downloadClicked, {
    widget: RevenueDashboardWidget.TopPlayers,
    page: AUDIENCE_PAGE,
  });

export const trackAudienceTopPlayersModalGranularityChanged = (granularity: ChartGranularity) =>
  mixpanelTrack(MIXPANEL_EVENT.audience.topPlayersModal.granularityChanged, {
    widget: RevenueDashboardWidget.TopPlayers,
    page: AUDIENCE_PAGE,
    granularity,
  });

export const trackAudienceTopPlayersModalHideSocialsToggled = (enabled: boolean) =>
  mixpanelTrack(MIXPANEL_EVENT.audience.topPlayersModal.hideSocialsToggled, {
    widget: RevenueDashboardWidget.TopPlayers,
    page: AUDIENCE_PAGE,
    enabled,
  });

export const trackAudienceTopPlayersModalRowSelectionToggled = (
  rowId: string,
  selected: boolean
) =>
  mixpanelTrack(MIXPANEL_EVENT.audience.topPlayersModal.rowSelectionToggled, {
    widget: RevenueDashboardWidget.TopPlayers,
    page: AUDIENCE_PAGE,
    rowId,
    selected,
  });

export const trackAudienceTopPlayersModalSelectAllToggled = (selected: boolean) =>
  mixpanelTrack(MIXPANEL_EVENT.audience.topPlayersModal.selectAllToggled, {
    widget: RevenueDashboardWidget.TopPlayers,
    page: AUDIENCE_PAGE,
    selected,
  });

export const trackAudienceTopDevicesModalOpened = () =>
  mixpanelTrack(MIXPANEL_EVENT.audience.topDevicesModal.opened, {
    widget: RevenueDashboardWidget.TopDevices,
    page: AUDIENCE_PAGE,
  });

export const trackAudienceTopDevicesModalDownloadClicked = () =>
  mixpanelTrack(MIXPANEL_EVENT.audience.topDevicesModal.downloadClicked, {
    widget: RevenueDashboardWidget.TopDevices,
    page: AUDIENCE_PAGE,
  });

export const trackAudienceTopDevicesModalDeviceSelectionToggled = (
  device: string,
  selected: boolean
) =>
  mixpanelTrack(MIXPANEL_EVENT.audience.topDevicesModal.deviceSelectionToggled, {
    widget: RevenueDashboardWidget.TopDevices,
    page: AUDIENCE_PAGE,
    device,
    selected,
  });
